import { confirm } from './components/confirm/Confirm';

interface TwoFactorModuleArgs {
    options: {
        unregisterMessage: string;
    };
}

function twoFactorModule({ options: { unregisterMessage } }: TwoFactorModuleArgs): void {
    const confirmUnregisterForm = document.getElementById('confirm-unregister-form');
    const confirmUnregisterSubmit = document.getElementById('confirm-unregister-submit');

    if (confirmUnregisterForm && !(confirmUnregisterForm instanceof HTMLFormElement)) {
        throw new Error('Form (#confirm-unregister-form) is not a form element.');
    }

    if (confirmUnregisterSubmit && confirmUnregisterForm) {
        confirmUnregisterSubmit.addEventListener('click', (event) => {
            event.preventDefault();
            confirm({
                message: unregisterMessage,
                onConfirm() {
                    confirmUnregisterForm.submit();
                },
            });
        });
    }
}

export default twoFactorModule;
